<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
@import 'assets/css/base.css';
@import 'assets/font/iconfont.css';
html,body{width:100%;height: 100%;}
#app {
  position: relative;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width:1200px;
  min-height:100%;
  background: #48596F;
  padding-bottom: 20px;

}
[content]{
  position: relative;
  width:1200px;
  margin:0 auto;
}
.pointer:hover{
  cursor: pointer;
}
.hover:hover{
  cursor: pointer;
}
div::-webkit-scrollbar{
  display: none;
}
.layout{
    position: absolute;
    width:100%;
    height: 100%;
    background: #48596F;
    display: flex;
    flex-direction: column;
}

</style>
